
$(document).ready(function(){
	
	$(".youtube").attr("href", "#top");
	
	$(".youtube").click(function(e) {
		var id = $(this).attr("data-youtubeid");
		$("#topPart").empty().append(youtubeEmbedCode(id));		
	});
	
});



function youtubeEmbedCode(id, autoplay) {
	
	if (autoplay === undefined || autoplay) {
		autoplay = 1;
	} else {
		autoplay = 0;
	}
	
	// old embed code
	var yt = '';
	yt += '<object class="youtube" width="640" height="385">';
	yt += '<param name="movie" value="http://www.youtube.com/v/'+id+'?rel=0&autohide=1&hd=1&modestbranding=1&theme=light&color=white&autoplay='+autoplay+'&version=3&amp;hl=en_US"></param>';
	yt += '<param name="allowFullScreen" value="true"></param>';
	yt += '<param name="allowscriptaccess" value="always"></param>';
	yt += '<embed src="http://www.youtube.com/v/'+id+'?rel=0&autohide=1&hd=1&modestbranding=1&theme=light&color=white&autoplay='+autoplay+'&version=3&amp;hl=en_US" type="application/x-shockwave-flash" width="640" height="385" allowscriptaccess="always" allowfullscreen="true"></embed></object>';
	return yt;
	
	// new embed code (doesn't work with new javascript security models
	//return '<iframe width="640" height="385" src="http://www.youtube.com/embed/'+id+'" frameborder="0" allowfullscreen></iframe>';
	
}